import BaseComponent from '../base-component/base-component'

const { Shopify }: any = window

class FreeShippingBar extends BaseComponent {
  messageNodeSelector: string

  constructor() {
    super()

    this.messageNodeSelector = '[data-free-shipping-bar-message]'
  }

  connectedCallback(): void {
    const cartTotal = this.dataset.cartTotal || 0

    this.updateProgressByCartTotal(+cartTotal)
  }

  updateProgressByCartTotal(cartTotal: number): void {
    const currencyFormat = this.dataset.currencyFormat || ''
    const threshold = +(this.dataset.threshold || 0)
    const currencyRate = +Shopify.currency.rate
    const progressMessage = this.dataset.progressMessage || ''
    const achievedMessage = this.dataset.achievedMessage || ''

    const thresholdInStoreCurrency = threshold * currencyRate
    const valueLeft = +(thresholdInStoreCurrency - cartTotal).toFixed(2)
    const moneyPerPercent = thresholdInStoreCurrency / 100

    if (valueLeft > 0) {
      const preparedValueLeft = currencyFormat.replace(
        /{{.+?}}/g,
        `${valueLeft}`,
      )

      this.setMessage(progressMessage.replace('[value]', preparedValueLeft))
      this.setProgress(cartTotal / moneyPerPercent)
    } else {
      this.setMessage(achievedMessage)
      this.setProgress(100)
    }
  }

  setProgress = (value: number): void => {
    this.style.setProperty(`--gsc-free-shipping-progress`, `${value}%`)
  }

  setMessage = (message: string): void => {
    const messageNode = this.querySelector(this.messageNodeSelector)

    if (messageNode) {
      messageNode.replaceChildren(message)
    }
  }
}

export default FreeShippingBar
